import {
    createLoadingSpinner,
    ILoadingSpinnerProperties,
    LoadingSpinner,
} from '@vfde-brix/ws10/loading-spinner';
import { HtmlId } from '../enums/elementId';
import { mountComponent } from '../util/mount';

export const mountLoadingSpinner = (wrapperId: HtmlId, nested = false) => {
    const props: ILoadingSpinnerProperties = {
        optNested: nested,
        optSize: 'medium',
        business: {},
    };

    return mountComponent(wrapperId, createLoadingSpinner, props);
};

export const updateLoadingSpinner = (comp: LoadingSpinner | undefined, show: boolean) => {
    if (!comp) {
        return;
    }

    comp.toggleContainer(!show);
    comp.toggle(show);
};
